import { render, staticRenderFns } from "./Promotion.vue?vue&type=template&id=2510aa1b"
import script from "@/scripts/adminManager/promotion/promotion.js?vue&type=script&lang=js&external"
export * from "@/scripts/adminManager/promotion/promotion.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports